import { useState } from 'react';

interface UseToggleOptions {
  initialState: boolean;
}

const useToggle = (options?: UseToggleOptions) => {
  const [state, setState] = useState(options?.initialState || false);

  const handleTrue = () => setState(true);
  const handleFalse = () => setState(false);
  const handleToggle = () => setState((prev) => !prev);

  return { state, handleFalse, handleTrue, handleToggle };
};

export default useToggle;
